import {Pipe, PipeTransform} from "@angular/core";

@Pipe({name: "detectImages"})
export class DetectImages implements PipeTransform {
  constructor() {
  }
  transform(value: string) {

    if (typeof value != "string") {
      return false;
    }
    value = value.toLowerCase();
    if (value.indexOf(".png")!=-1) {
      return true;
    } else if (value.indexOf(".gif")!=-1) {
      return true;
    } else if (value.indexOf(".jpg")!=-1) {
      return true;
    } else if (value.indexOf(".jpeg")!=-1) {
      return true;
    } else if (value.includes("data:image/")) {
      return true;
    } else {
      return false;
    }
  }
}




// WEBPACK FOOTER //
// ./src/pipes/detectImages.ts